export default [
    {
        path: '/platinum/hotel',
        props: true,
        component: () => import('@/views/PlatinumHotel'),
    },
];
